import { convert } from '../utils'

let lines = [

  {text: ['优胜美地的山巨人'],startTime: '00:00:01.00', endTime: '00:00:03.03'},
  {text: ['有的很瘦 有的很胖'],startTime: '00:00:03.04', endTime: '00:00:06.07'},
  {text: ['但他们都很懒'],startTime: '00:00:06.08', endTime: '00:00:08.18'},
  {text: ['他们几百年来','都躺在这里呼呼大睡'],startTime: '00:00:08.19', endTime: '00:00:13.17'},
  {text: ['全加利“孩”尼亚的人','都拿他们没办法'],startTime: '00:00:13.18', endTime: '00:00:18.02'},
  {text: ['看 有个长着圆脑袋','的巨人好像动了一下'],startTime: '00:00:18.03', endTime: '00:00:22.23'},
  {text: ['是不是你把它吵醒了呀'],startTime: '00:00:22.24', endTime: '00:00:26.01'},
  {text: ['我们快跟他挥挥手','打声招呼吧'],startTime: '00:00:26.02', endTime: '00:00:29.05'},

]

export default convert(lines)
